"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ApptList;
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/values"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _xstate = require("xstate");
var _moment = _interopRequireDefault(require("moment"));
var _TimeFilter = _interopRequireDefault(require("../TimeFilter"));
var _GroupedAppts = _interopRequireDefault(require("./GroupedAppts"));
var _LoadMoreBtn = _interopRequireDefault(require("./LoadMoreBtn"));
var _styles = require("./styles");
var _Banners = require("../../Banners");
var _WeekDayFilter = _interopRequireDefault(require("../WeekDayFilter"));
var _States = require("../../../lib/constants/States");
var _ApptList = require("./ApptList.utils");
var _configUtils = require("../../../lib/configUtils");
var _FilterToolbar = _interopRequireDefault(require("../FilterToolbar"));
var _messages = _interopRequireDefault(require("../../../lib/messages"));
var _propTypes2 = require("../../../lib/propTypes");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const propTypes = {
  currentState: (0, _propTypes.instanceOf)(_xstate.State).isRequired,
  appointments: _propTypes.array.isRequired,
  locations: _propTypes.array.isRequired,
  onClearFilters: _propTypes.func.isRequired,
  onDayOfWeekChange: _propTypes.func.isRequired,
  onDateChange: _propTypes.func.isRequired,
  onTimeOfDayChange: _propTypes.func.isRequired,
  onLoadMore: _propTypes.func.isRequired,
  onSelectAppt: _propTypes.func.isRequired,
  onHighlightLocId: _propTypes.func.isRequired,
  query: _propTypes.object.isRequired,
  config: _propTypes2.configType,
  track: _propTypes.func,
  apptDensity: (0, _propTypes.oneOf)(['default', 'dense']),
  provider: _propTypes.object.isRequired
};
function ApptList(_ref) {
  var _context;
  let {
    currentState,
    appointments,
    locations,
    onClearFilters,
    onDayOfWeekChange,
    onTimeOfDayChange,
    onLoadMore,
    onSelectAppt,
    onHighlightLocId,
    query,
    config,
    onDateChange,
    track,
    apptDensity = 'default',
    provider
  } = _ref;
  const {
    filterBy,
    periodStart,
    firstNewAppointmentId,
    jumpedToDate
  } = currentState.context;
  (0, _react.useLayoutEffect)(() => {
    if (firstNewAppointmentId) {
      const slotNode = document.getElementById(firstNewAppointmentId);
      slotNode && slotNode.focus();
    }
  }, [firstNewAppointmentId]);
  const batchedAppointments = (0, _react.useMemo)(() => {
    return (0, _ApptList.batchAppointmentsByDay)(appointments, filterBy);
  }, [appointments, filterBy]);

  // Part of a unique key used to detect filtering while rendering the list of
  // batched appointments.
  const timeOfDayKey = `TD:${[...(0, _values.default)(_context = filterBy.timeOfDay).call(_context)].join()}`;
  const locById = (0, _reduce.default)(locations).call(locations, (acc, cur) => {
    acc[cur.id] = cur;
    return acc;
  }, {});

  /**
   * If we don't have any `batchedAppointments` at this point,
   * then it's because they were filtered out.*/
  const noFilteredResults = batchedAppointments.length === 0;
  const noFilters = currentState.context.filterBy.timeOfDay.size + currentState.context.filterBy.dayOfWeek.size === 0;
  const showNoResultsBanner = noFilteredResults || currentState.matches(`${_States.jumpToDate}.${_States.noResults}`);
  const noMoreResults = currentState.matches(`${_States.nextSearch}.${_States.noResults}`);
  const noResultsBanner = currentState.matches(`${_States.jumpToDate}.${_States.noResults}`) ? /*#__PURE__*/_react.default.createElement(_Banners.NoResultsBanner, {
    resultsMessage: _messages.default.noJumpToDateResults,
    date: currentState.context.query.periodStart,
    onClearFilters: noFilters ? undefined : onClearFilters
  }) : /*#__PURE__*/_react.default.createElement(_Banners.NoResultsBanner, {
    resultsMessage: noMoreResults ? _messages.default.noFilteredResultsNoMoreResults : _messages.default.noFilteredResults,
    jumpedToDate: jumpedToDate || (0, _moment.default)() // Should pick current date as fallback, if we don't select any date in picker and applies filter.
    ,
    date: appointments[appointments.length - 1]?.start_datetime,
    isLoading: currentState.matches(`${_States.nextSearch}.${_States.pending}`),
    onLoadMore: noMoreResults ? undefined : onLoadMore,
    onClearFilters: noFilters ? undefined : onClearFilters
  });
  return /*#__PURE__*/_react.default.createElement(_styles.Container, {
    "data-testid": "ApptList"
  }, (0, _configUtils.isDirectBookRenderedInDrawer)(config) ? null : (0, _ApptList.shouldUseJumpToDate)(config) ? /*#__PURE__*/_react.default.createElement(_FilterToolbar.default, {
    filterBy: filterBy,
    onDayOfWeekChange: onDayOfWeekChange,
    onTimeOfDayChange: onTimeOfDayChange,
    onDateChange: onDateChange,
    selectedDate: jumpedToDate,
    track: track
  }) : /*#__PURE__*/_react.default.createElement(_styles.Toolbar, {
    "data-testid": "ApptList__LegacyFilterBar"
  }, /*#__PURE__*/_react.default.createElement(_WeekDayFilter.default, {
    filterBy: filterBy,
    onChange: onDayOfWeekChange
  }), /*#__PURE__*/_react.default.createElement(_TimeFilter.default, {
    filterBy: filterBy,
    onChange: onTimeOfDayChange
  })), showNoResultsBanner ? noResultsBanner : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, currentState.matches(`${_States.newSearch}.${_States.deepLinkingTimeSlotUnavailableError}`) && /*#__PURE__*/_react.default.createElement(_Banners.DeepLinkingUnavailableSlotBanner, {
    slotTime: (0, _ApptList.formatTimeForErrorMsg)(periodStart)
  }), (0, _map.default)(batchedAppointments).call(batchedAppointments, _ref2 => {
    let {
      header,
      byLocId
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_GroupedAppts.default, {
      locById: locById
      // key with timeOfDay used for animation to detect filtering
      ,
      key: `${header}__${timeOfDayKey}`,
      header: header,
      groupByLocId: byLocId,
      onSelectAppt: onSelectAppt,
      onHighlightLocId: onHighlightLocId,
      query: query,
      shouldUseJumpToDate: (0, _ApptList.shouldUseJumpToDate)(config),
      apptDensity: apptDensity,
      disableExpandCollapse: (0, _configUtils.isDirectBookRenderedInDrawer)(config),
      track: track,
      shouldShowRegulatedSpacesBanner: (0, _ApptList.shouldShowRegulatedSpacesBanner)(config),
      provider: provider
    });
  }), /*#__PURE__*/_react.default.createElement(_LoadMoreBtn.default, {
    config: config,
    currentState: currentState,
    onClick: onLoadMore
  })));
}
ApptList.propTypes = propTypes;
ApptList.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ApptList",
  "props": {
    "apptDensity": {
      "defaultValue": {
        "value": "'default'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'default'",
          "computed": false
        }, {
          "value": "'dense'",
          "computed": false
        }]
      },
      "required": false
    },
    "currentState": {
      "description": "",
      "type": {
        "name": "instanceOf",
        "value": "State"
      },
      "required": true
    },
    "appointments": {
      "description": "",
      "type": {
        "name": "array"
      },
      "required": true
    },
    "locations": {
      "description": "",
      "type": {
        "name": "array"
      },
      "required": true
    },
    "onClearFilters": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "onDayOfWeekChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "onDateChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "onTimeOfDayChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "onLoadMore": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "onSelectAppt": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "onHighlightLocId": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "query": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": true
    },
    "config": {
      "description": "",
      "type": {
        "name": "custom",
        "raw": "configType"
      },
      "required": false
    },
    "track": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "provider": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": true
    }
  }
};